// Perfis e permissoes do backoffice. A API e quem garante (403 em toda rota
// sem permissao); aqui so se esconde o que o perfil nao pode usar.
//
// Permissao = "modulo.acao" (ex.: "course.create"), do catalogo da API em
// src/modules/domain/backoffice/access/permissions.catalog.ts. A regra de uma
// tela ou botao pode ser:
//   - "course.create"           uma permissao
//   - ["groups.list", "x.y"]    qualquer uma delas
//   - { superAdmin: true }      so o Administrador
//   - undefined                 qualquer admin logado

export function accessAllows(access, rule) {
  if (!rule) return true;
  if (access?.profile?.isSuperAdmin) return true;
  if (rule.superAdmin) return false;

  const permissions = access?.permissions || [];
  const required = Array.isArray(rule) ? rule : [rule];
  return required.some((item) => permissions.includes(item));
}

// Vue.use(PermissionsPlugin, { store }): this.$can(regra) e
// this.$isSuperAdmin() em qualquer componente. Le o store a cada chamada, entao
// o template reage quando o acesso muda (login, F5, troca de perfil).
export const PermissionsPlugin = {
  install(Vue, { store }) {
    Vue.prototype.$can = (rule) => accessAllows(store.getters.access, rule);
    Vue.prototype.$isSuperAdmin = () =>
      !!store.getters.access?.profile?.isSuperAdmin;
  },
};
